import { render, staticRenderFns } from "./RptSalTraTot_BAK.vue?vue&type=template&id=74e2e1a0"
import script from "./RptSalTraTot_BAK.vue?vue&type=script&lang=js"
export * from "./RptSalTraTot_BAK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports